
import { TickerInfo, TimeFrame, TickerAssetType, TimeFrameType } from '../config/tickers';
import { TVContext } from './context';
import { DateTime, DayOfWeek } from './datetime';


const day24hMins = 24 * 60;
const week7Mins = 7 * 24 * 60;
export class TimeFrameHelper {
	static adjustTVTime2(ticker: TickerInfo, tvat: number, from: TimeFrame, to: TimeFrame): number {
		/*let iat = new DateTime(tvat);*/
		let at: DateTime = new DateTime(tvat);
		if (to.o < from.o) {
			if (from.t < TimeFrameType.Day || !TimeFrameHelper.hasRegularTradingHours(ticker)) {
				at = TimeFrameHelper.addBar(to, ticker, at, 0, from.t);
			} else {
				if (to.o < TimeFrameType.Day)
					at = TimeFrameHelper.GetIntradayStart(ticker, to, at);
				at = TimeFrameHelper.addBar(to, ticker, at, 0, from.t);
			}
		} else {
			at = TimeFrameHelper.addBar(to, ticker, at, 0, from.t);
		}
		return at.Ticks;

	}
	static adjustTVTime(tvd: TVContext, tvat: number, from: TimeFrame): number {
		const to = tvd.getTimeFrameInfo();
		const ticker = tvd.getTickerInfo();
		return TimeFrameHelper.adjustTVTime2(ticker, tvat, from, to);

	}
	private static hasRegularTradingHours(ticker: TickerInfo) {
		switch (ticker.asset) {
			case TickerAssetType.Crypto:
			case TickerAssetType.Formula:
				return false;
		}
		return true;
	}
	private static GetIntradayStart(ticker: TickerInfo, tf: TimeFrame, dailyAt: DateTime) {
		if (tf.t >= TimeFrameType.Day)
			throw 'wrong tf';
		if (!TimeFrameHelper.hasRegularTradingHours(ticker))
			return dailyAt;
		var at = dailyAt;
		if (ticker.startsPrevDay)
			at = at.Date.AddDays(-1).Add(ticker.open);
		else
			at = at.Date.Add(ticker.open);
		at = TimeFrameHelper.ConvertToUTC(ticker, at);
		return at;
	}
	static addBar(tf: TimeFrame, ticker: TickerInfo, at: DateTime, bars: number, from: TimeFrameType = TimeFrameType.Min): DateTime {
		switch (ticker.asset) {
			case TickerAssetType.Crypto:
			case TickerAssetType.Formula:
				break;
			default:
				switch (tf.t) {
					case TimeFrameType.Min:
						return convertMins(tf.q);
					case TimeFrameType.Hour:
						return convertMins(tf.q * 60);
					case TimeFrameType.Day:
						return convertDays(tf.q);
					case TimeFrameType.Week:
						return convertWeeks(tf.q);
					case TimeFrameType.Month:
						return convertMonths(tf.q);
				}
		}

		switch (tf.t) {
			case TimeFrameType.Min: {
				let atr = at.Date;
				atr = atr.AddHours(at.Hour);
				atr = atr.AddMinutes(Math.floor(at.Minute / tf.q) * tf.q + bars * tf.q);
				return atr;
			}
			case TimeFrameType.Hour: {
				let atr = at.Date;
				atr = atr.AddHours(Math.floor(at.Hour / tf.q) * tf.q + bars * tf.q);
				return atr;
			}
			case TimeFrameType.Day: {
				let start = DateTime.FromDate(at.Year, 1, 1);
				const days = at.Deduct(start).TotalDays;
				let yearBars = Math.ceil(start.GetYearDays() / tf.q);
				let totalBars = Math.floor(days / tf.q) + bars;
				while (totalBars > yearBars) {
					start = start.AddYears(1);
					totalBars -= yearBars;
					yearBars = Math.ceil(start.GetYearDays() / tf.q);
				}
				var t = start.AddDays(totalBars * tf.q);
				return t;
			}
			case TimeFrameType.Week: {
				const days = at.Deduct(DateTime.UnixEpochMon).TotalDays;
				let totalBars = Math.floor(days / 7);
				totalBars += bars;
				return DateTime.UnixEpochMon.AddDays(totalBars * 7);
			}
			case TimeFrameType.Month:
				return DateTime.FromDate(at.Year, at.Month, 1).AddMonths(bars);
		}
		function getPrevDayMins() {
			if (!ticker.startsPrevDay)
				return 0;
			return 24 * 60 - ticker.open / DateTime.TicksPerMinute;
		}
		//return at;
		function isFullDay() {
			switch (ticker.asset) {
				case TickerAssetType.FX:
				case TickerAssetType.Commodities:
				case TickerAssetType.Indices:
				case TickerAssetType.Crypto:
				case TickerAssetType.Formula:
					return true;
			}
			return false;
		}
		function getWeekDays() {
			switch (ticker.asset) {
				case TickerAssetType.FX:
				case TickerAssetType.Commodities:
				case TickerAssetType.Indices:
				case TickerAssetType.Stocks:
				case TickerAssetType.OTC:
					return 5;
			}
			return 7;
		}
		///todo session.WeekMins
		function getWeekMins() {
			return getDayMins() * getWeekDays();
		}
		///todo session.DayMins
		function getDayMins() {
			if (isFullDay())
				return 24 * 60;
			return Math.floor((ticker.close - ticker.open) / DateTime.TicksPerMinute);
		}
		function convertMins(mp: number) {
			let atr = TimeFrameHelper.prepareDate(ticker, at);
			let start: DateTime;
			if (ticker.startsPrevDay)
				start = atr.Date.AddDays(-(atr.DayOfWeek - DayOfWeek.Sunday)).Add(ticker.open);
			else
				start = atr.Date.AddDays(-(atr.DayOfWeek - DayOfWeek.Monday));

			let total = Math.floor(atr.Deduct(start).TotalMinutes);
			if (total < 0) {
				atr = start;
				total = 0;
			}

			const weekDays = getWeekDays();

			const openMins = Math.floor(ticker.open / DateTime.TicksPerMinute);
			if (isFullDay()) {
				let weekMins = weekDays * day24hMins;
				total = Math.floor(total / week7Mins) * weekMins + total % week7Mins;
				total = Math.floor(total / mp) * mp + mp * bars;
				total = Math.floor(total / weekMins) * week7Mins + total % weekMins;
			} else {
				let dayMins = getDayMins();

				let weekMins = weekDays * day24hMins;
				total = Math.floor(total / week7Mins) * weekMins + total % week7Mins;

				let totalDays = Math.floor(total / day24hMins);
				let lastDayMins = total % day24hMins - openMins;

				let dayBars = Math.floor(dayMins / mp) + (dayMins % mp != 0 ? 1 : 0);

				let lastDayBars = Math.floor(lastDayMins / mp);
				let totalBars = totalDays * dayBars + bars + lastDayBars;

				totalDays = Math.floor(totalBars / dayBars);
				lastDayMins = (totalBars % dayBars) * mp;
				total = totalDays * day24hMins + lastDayMins + openMins;

				total = Math.floor(total / weekMins) * week7Mins + total % weekMins;
			}
			var rAtr = start.AddMinutes(total);
			atr = rAtr;
			atr = TimeFrameHelper.ConvertToUTC(ticker, atr);
			return atr;
		}
		function convertDays(mp: number) {
			let atr: DateTime;
			let prevDayMins = 0;
			if (from >= TimeFrameType.Day) {
				atr = at;
			} else {
				atr = TimeFrameHelper.ConvertFromUTC(ticker, at);
				prevDayMins = getPrevDayMins();// (int)session.PrevDayTime.TotalMinutes;//todo;
			}
			const weekDays = getWeekDays();//session.WeekDays 
			const weekMins = getWeekMins();//todo session.WeekMins
			const dayMins = getDayMins();//todo session.DayMins

			if (ticker.startsPrevDay) {
				let yearStartDay = getYearStartDay(atr, mp);
				let total = prevDayMins + Math.floor(atr.Deduct(yearStartDay.start.Date).TotalMinutes);
				let exchangeTotal = Math.floor(total / week7Mins) * weekMins + total % week7Mins;
				if (yearStartDay.skipDays > 0)
					exchangeTotal -= yearStartDay.skipDays * dayMins;

				let tfMins = dayMins * mp;
				let alignedTotal = Math.floor(exchangeTotal / tfMins) + 1 + bars;

				while (alignedTotal > yearStartDay.yearBars) {
					if (yearStartDay.skipDays > 0)
						yearStartDay.start = yearStartDay.start.AddDays(yearStartDay.skipDays);
					yearStartDay.start = yearStartDay.start.AddYears(1);
					alignedTotal -= yearStartDay.yearBars;
					yearStartDay = getYearStartDay(yearStartDay.start, mp);
					//skipMins = skipDays * session.DayMins;
				}
				alignedTotal--;
				alignedTotal *= tfMins;
				if (yearStartDay.skipDays > 0)
					alignedTotal += yearStartDay.skipDays * dayMins;
				alignedTotal = Math.floor(alignedTotal / weekMins) * week7Mins + (alignedTotal % weekMins);
				var t = yearStartDay.start.Date.AddMinutes(alignedTotal);
				return t;

			} else {
				let yearStartDay = getYearStartDay(atr, mp);

				let totalDays = Math.floor(atr.Date.Deduct(yearStartDay.start.Date).TotalDays);
				totalDays = Math.floor(totalDays / 7) * weekDays + (totalDays % 7);
				if (yearStartDay.skipDays > 0)
					totalDays -= yearStartDay.skipDays;
				let totalBars = Math.floor(totalDays / mp) + 1 + bars;

				while (totalBars > yearStartDay.yearBars) {
					if (yearStartDay.skipDays > 0)
						yearStartDay.start = yearStartDay.start.AddDays(yearStartDay.skipDays);
					yearStartDay.start = yearStartDay.start.AddYears(1);
					totalBars -= yearStartDay.yearBars;
					yearStartDay = getYearStartDay(yearStartDay.start, mp);
				}

				totalDays = (totalBars - 1) * mp;
				if (yearStartDay.skipDays > 0)
					totalDays += yearStartDay.skipDays;
				totalDays = Math.floor(totalDays / weekDays) * 7 + (totalDays % weekDays);
				var t = yearStartDay.start.Date.AddDays(totalDays);
				return t;
			}
		}
		function convertWeeks(mp: number) {
			let atr: DateTime;
			if (from >= TimeFrameType.Day)
				atr = at;
			else {
				atr = TimeFrameHelper.ConvertFromUTC(ticker, at);
				atr = atr.AddMinutes(getPrevDayMins());
			}
			let days = Math.floor((atr.Deduct(DateTime.UnixEpochMon)).TotalDays);
			let totalBars = Math.floor(days / (7 * mp));
			totalBars += bars;
			return DateTime.UnixEpochMon.AddDays(totalBars * (7 * mp));
		}
		function convertMonths(mp: number) {
			let atr: DateTime;

			if (from >= TimeFrameType.Day)
				atr = at;
			else {
				atr = TimeFrameHelper.ConvertFromUTC(ticker, at);
				atr = atr.AddMinutes(getPrevDayMins());
			}
			return DateTime.FromDate(atr.Year, atr.Month, 1).AddMonths(bars);
		}
		function getYearStartDay(atr: DateTime, mp: number) {
			let skipDays = 0;
			let yearBars = 0;
			let year = atr.Year;
			if (ticker.startsPrevDay)
				if (atr.Month == 12 && atr.Day == 31 && atr.TimeOfDay >= ticker.open)
					year++;

			let start = DateTime.FromDate(year, 1, 1);
			switch (start.DayOfWeek) {
				case DayOfWeek.Sunday:
					skipDays = -1;
					break;
				case DayOfWeek.Saturday:
					skipDays = -2;
					break;
				default:
					skipDays = start.DayOfWeek - DayOfWeek.Monday;
					break;
			}
			const weekDays = 5;
			start = start.AddDays(-skipDays);
			let yearDays = start.GetYearDays() + skipDays;
			yearDays = Math.floor(yearDays / 7) * weekDays + (yearDays % 7);
			if (skipDays > 0)
				yearDays -= skipDays;
			yearBars = Math.ceil(yearDays / mp);
			return {
				start: start.Add(ticker.open),
				skipDays: skipDays,
				yearBars: yearBars
			}
		}

	}

	//public static readonly TimeZoneInfo newYorkTZ = TimeZoneInfo.FindSystemTimeZoneById("Eastern Standard Time");

	private static ConvertFromUTC(ticker: TickerInfo, at: DateTime) {
		switch (ticker.asset) {
			case TickerAssetType.Formula:
			case TickerAssetType.Crypto:
			case TickerAssetType.Commodities:
			case TickerAssetType.Indices:
				return at;
		}
		return new DateTime(DateTime.convertFromUTC(at.Ticks, "America/New_York"));
	}
	private static ConvertToUTC(ticker: TickerInfo, at: DateTime) {
		switch (ticker.asset) {
			case TickerAssetType.Formula:
			case TickerAssetType.Crypto:
			case TickerAssetType.Commodities:
			case TickerAssetType.Indices:
				return at;
		}
		return new DateTime(DateTime.convertToUTC(at.Ticks, "America/New_York"));
	}

	private static prepareDate(ticker: TickerInfo, at: DateTime): DateTime {
		let atr = TimeFrameHelper.ConvertFromUTC(ticker, at);
		switch (atr.DayOfWeek) {
			case DayOfWeek.Saturday: {
				//move to the friday last bar
				atr = atr.Date.AddDays(-1).Add(ticker.close).AddMinutes(-1);
			}
				break;
			case DayOfWeek.Sunday: {
				let resetFri = true;
				if (ticker.startsPrevDay)
					resetFri = atr.TimeOfDay < ticker.open;
				//move to the friday last bar
				if (resetFri)
					atr = atr.Date.AddDays(-2).Add(ticker.close).AddMinutes(-1);
			}
				break;
			case DayOfWeek.Friday:
				if (ticker.startsPrevDay) {
					if (atr.TimeOfDay >= ticker.close)
						atr = atr.Date.Add(ticker.close).AddMinutes(-1);
				} else {
					if (atr.TimeOfDay < ticker.open)
						atr = atr.AddDays(-1).Add(ticker.close).AddMinutes(-1);
					else if (atr.TimeOfDay >= ticker.close)
						atr = atr.Date.Add(ticker.close).AddMinutes(-1);
				}
				break;
			default:
				if (!ticker.startsPrevDay) {
					if (atr.TimeOfDay < ticker.open) {
						let days = 1;
						if (atr.DayOfWeek == DayOfWeek.Monday)
							days = 3;
						atr = atr.AddDays(-days).Add(ticker.close).AddMinutes(-1);
					} else if (atr.TimeOfDay >= ticker.close) {
						atr = atr.Date.Add(ticker.close).AddMinutes(-1);
					}
				}
				break;
		}
		return atr;
	}
}
